import classes from './PriceItemOutput.module.css'

const PriceItemOutput = (props) => {
  // label
  // thbValue
  // forexValue
  // forexSymbol
  // isDiscount (boolean) - makes label red
  // flashDeal (boolean) - shows "Flash Deal" text

  const labelClass = props.isDiscount ? classes.labelTextDiscount : classes.labelText;
  const isNegativeValue = props.thbValue && props.thbValue.toString().startsWith('-');
  const thbTextClass = isNegativeValue ? classes.thbTextDiscount : classes.thbText;
  const forexTextClass = isNegativeValue ? classes.forexTextDiscount : classes.forexText;

  return (
    <div className={classes.itemContainer}>
      <div className={classes.labelRowContainer}>
        <div className={classes.itemLabelContainer}>
          <p className={labelClass}>{props.label}</p>
        </div>
        <div className={classes.valuesContainer}>
          <div className={classes.thbContainer}>
            <p className={thbTextClass}>{props.thbValue} THB</p>
          </div>
          {props.forexSelected && (
            <div className={classes.forexContainer}>
              <p className={forexTextClass}>
                {props.forexValue} {props.forexSymbol}
              </p>
            </div>
          )}
        </div>
      </div>
      {props.flashDeal && (
        <p className={classes.flashDealText}>Flash Deal Limited Time Only</p>
      )}
    </div>
  )
}

export default PriceItemOutput
